export const useLoading = (startWithLoading = false) => {
  const isLoading = ref(startWithLoading);

  const handleLoading = async <T = unknown>(promise: Promise<T>) => {
    isLoading.value = true;

    promise.finally(() => {
      isLoading.value = false;
    });

    return promise;
  };

  return {
    isLoading,
    handleLoading
  };
};
